module.exports = __webpack_public_path__ + "static/media/caret-down-solid.397d03b8.svg";